import React from 'react';
import { useTranslation } from 'react-i18next';
import Separator from '@lsq/nextgen/v2/separator';
import CustomInputV2 from '../../../../components/CustomInputV2';
import { globalConstants } from '../../../../constants/globalConstant';
import SortFilter from '../../../../components/reusableComponents/listing/ListingHeader/SortFilter';
import StatusFilter from '../../../../components/reusableComponents/listing/ListingHeader/StatusFilter';
import styles from './TeamsHeader.module.css';

const TeamsHeader = ({
  searchState,
  sortState,
  sortItems,
  platformFilterItems,
  selectedPlatform,
  onPlatformSelect
}) => {
  const { t } = useTranslation();
  const [searchValue, onSearchChange] = searchState;

  return (
    <>
      <div className={styles['header-row']}>
        <h2 className="ng_h_2_b">{globalConstants.TEAM_MANAGEMENT}</h2>
      </div>

      <div className={styles['filter-row']}>
        <CustomInputV2
          placeholder={t('Search Teams')}
          value={searchValue}
          onChange={(e) => onSearchChange(e.target.value)}
          data-testid="teams-search"
          size="xs"
        />
        <Separator orientation="vertical" length="100%" />
        <SortFilter sortState={sortState} sortItems={sortItems} />
        {platformFilterItems && platformFilterItems.length > 0 && (
          <StatusFilter
            filterItems={platformFilterItems}
            selected={selectedPlatform}
            onSelect={onPlatformSelect}
            label="Platform"
            showClear={false}
          />
        )}
      </div>
    </>
  );
};

export default TeamsHeader;
